<template>
    <div id="login-mask"
         @keyup.enter="handleSubmit"
         v-if="!status.loggedIn">
        <v-form v-model="valid">

            <v-container class="login-input logo-container">
                <v-row justify="center">
                    <img alt="MK" src="../assets/firework.png" width="150" height="150">
                </v-row>
            </v-container>

            <v-container class="login-input">
                <v-row>
                    <v-col>
                        <v-text-field v-model="username"
                                      prepend-inner-icon="mdi-account-box"
                                      label="Username"
                                      :rules="[rules.required]"
                                      required></v-text-field>
                        <div v-show="submitted && !username">Username is required</div>
                    </v-col>
                </v-row>
            </v-container>

            <v-container class="login-input">
                <v-row>
                    <v-col>
                        <v-text-field v-model="password"
                                      prepend-inner-icon="mdi-lock"
                                      :append-icon="showPasswd ? 'mdi-eye-off' : 'mdi-eye'"
                                      :rules="[rules.required, rules.min]"
                                      :type="showPasswd ? 'text' : 'password'"
                                      name="input-10-2"
                                      label="Password"
                                      hint="At least 8 characters"
                                      value=""
                                      class="input-group--focused"
                                      @click:append="showPasswd = !showPasswd">
                        </v-text-field>
                        <div v-show="submitted && !password">Password is required</div>
                    </v-col>
                </v-row>
            </v-container>

            <v-container class="login-input">
                <v-row>
                    <v-col md4>
                        <v-btn @click.prevent="handleSubmit" color="info" :disabled="(status.loggingIn || !username || !password)">Login</v-btn>
                        <span class="spinner" style="margin-left:.5em;vertical-align:text-top;"
                            v-if="status.loggingIn"></span>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>
    </div>
</template>


<script>
    import { mapState, mapActions } from 'vuex'

    export default {
        data () {
            return {
                username: '',
                password: '',
                submitted: false,

                showPasswd: false,
                rules: {
                    required: value => !!value || 'Required.',
                    min: v => v.length >= 8 || 'Min 8 characters',
                    emailMatch: () => ('The email and password you entered don\'t match')
                },

                valid: false,
            }
        },

        computed: {
            ...mapState('user', ['status'])
        },

        created () {
            // reset login status
            if (this.status !== 'loggedIn') {
                this.logout()
            }
        },

        methods: {
            ...mapActions({
                login: 'user/login',
                logout: 'user/logout',
            }),
            handleSubmit (e) {
                this.submitted = true;
                const { username, password } = this;
                if (username && password) {
                    this.login({ username, password, next: this.$route.query.next })
                        .then(result => {
                        })
                }
            },
            submit() {
                this.$v.$touch()
            },
        },

        mounted() {
        }
    }
</script>


<style>
    #login-mask {
        margin-top: 2%;
    }

    .login-input {
        max-width: 500px;
    }

    .logo-container {
        display: flex;
        justify-content: space-around;
    }

    .login-input .spinner {
        position: relative;
    }

    .login-input .spinner:before {
        top: 100%;
        left: 1.5em;
        width: 1.5em;
        height: 1.5em;
        border: 2px solid #ccc;
        border-top-color: #ee7214;
    }
</style>